/**
 * Three glows as pre-blurred gradients (no blur filter: cheap on a phone's webview,
 * review 0012 S9), placed and timed as in the design.
 */
const ORBS = [
  { id: "violet", x: 20, y: 20, r: 320, color: "var(--p-violet)", seconds: 18, delay: 0 },
  { id: "sky", x: 80, y: 30, r: 380, color: "var(--p-sky)", seconds: 23, delay: -4 },
  { id: "amber", x: 55, y: 85, r: 420, color: "var(--p-gold-deep)", seconds: 28, delay: -8 },
];

const GLYPHS = ["♠", "♥", "♦", "♣"];

/** Eighteen suits at fixed places (the design's formula), so screenshots do not move. */
const SUITS = Array.from({ length: 18 }, (_, i) => ({
  id: `suit-${i}`,
  glyph: GLYPHS[i % 4] ?? "♠",
  x: (i * 53) % 100,
  y: (i * 37 + 11) % 100,
  size: 40 + (i % 5) * 22,
  gold: i % 2 === 1,
  seconds: 26 + (i % 7) * 6,
  delay: -i * 3,
}));

/** The moving background behind sign-in and the lobby (design); still under reduced motion (base.css). */
export function Backdrop() {
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 overflow-hidden bg-lobby">
      {ORBS.map((orb) => (
        <span
          key={orb.id}
          className="absolute -translate-x-1/2 -translate-y-1/2 rounded-full opacity-35"
          style={{
            left: `${orb.x}%`,
            top: `${orb.y}%`,
            width: orb.r * 2,
            height: orb.r * 2,
            background: `radial-gradient(circle, ${orb.color} 0%, transparent 68%)`,
            animation: `glow ${orb.seconds}s ease-in-out ${orb.delay}s infinite`,
          }}
        />
      ))}
      {SUITS.map((suit) => (
        <span
          key={suit.id}
          className={`absolute leading-none ${suit.gold ? "text-gold/10" : "text-ink/7"}`}
          style={{
            left: `${suit.x}%`,
            top: `${suit.y}%`,
            fontSize: suit.size,
            animation: `drift ${suit.seconds}s ease-in-out ${suit.delay}s infinite`,
          }}
        >
          {suit.glyph}
        </span>
      ))}
    </div>
  );
}
